import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from "react-redux";
import cx from 'classnames';

import SwitchButton from "../../Common/Switch/SwitchButton";
import Link from "../../Link/Link";
import { getCurrencySymbol } from "../../../helpers/currencyConvertion";

import { api, subCategoryUploadDir } from "../../../config";
import messages from "../../../locale/messages";

import { openBaseFareModal } from '../../../actions/siteadmin/modalActions';

import defaultSubServiceCheckedIcon from '../../../../public/Icons/defaultSubServiceCheckedIcon.svg'
import { EditFareIcon } from "../../Common/Assets/SVGIcon/CommonSvgIcon";
import s from './ManageSubCategoryItem.css';

const ManageSubCategoryItem = ({
    isDefaultChecked,
    subCategoryId,
    categoryId,
    subCategoryName,
    image,
    onToggle,
    baseFare,
    multiplierValue,
    pricingType,
    isPriceEditable,
    profileId,
    userCurrency,
    intl: { formatMessage },
    openBaseFareModal
}) => {
    const [isChecked, setIsChecked] = useState(false);

    useMemo(() => {
        setIsChecked(isDefaultChecked);
    }, [isDefaultChecked]);

    useEffect(() => {
        if (isChecked) {
            onToggle(categoryId, subCategoryId, isChecked, baseFare);
        }
    }, [baseFare]);

    const handleChange = useCallback(() => {
        const newCheckedState = !isChecked;
        setIsChecked(newCheckedState);
        onToggle(categoryId, subCategoryId, newCheckedState, baseFare);
    }, [isChecked, categoryId, subCategoryId, baseFare, onToggle]);

    const handlePopupModal = (e) => {
        e.preventDefault();
        let symbol = getCurrencySymbol(userCurrency)
        const formName = 'BaseFareForm'
        const initialValues = {
            id: subCategoryId,
            mainCategoryId: categoryId,
            baseFare: baseFare,
            pricingType: pricingType,
            subCategoryName: subCategoryName,
            profileId: profileId,
            symbol: symbol,
            currency: userCurrency
        }

        openBaseFareModal(subCategoryName, initialValues, formName)
    }

    let symbol = getCurrencySymbol(userCurrency);

    return (
        <>
            <div className={s.manageSubCategoryCardTopWrapper}>
                <div className={cx(s.manageSubCategoryCardImgContainer, 'manageSubCategoryCardImgContainerRtl')}>
                    <img src={`${api.apiEndpoint}${subCategoryUploadDir}medium_${image}`} height={200} width={200} className={s.manageSubCategoryCardImg} />
                </div>
                <div className={s.manageSubCategoryCardInfoContainer}>
                    <div className={s.manageSubCategoryCardInfoWrapper}>
                        <div className={s.manageSubCategoryCardInfoName}>{subCategoryName}</div>
                        <div className={s.manageSubCategoryCardInfoQuantityCountText}>
                            {
                                pricingType === 'fixed' ? (
                                    <>
                                        <><FormattedMessage {...messages.maxQuantityLabel} />&nbsp;</>
                                        <span>{multiplierValue}</span>
                                    </>
                                ) : (
                                    <>
                                        <><FormattedMessage {...messages.minHourLabel} />&nbsp;</>
                                        <span>{multiplierValue}</span>
                                    </>
                                )
                            }
                        </div>
                    </div>
                    <div className={s.manageSubCategoryCardSwitchWrapper}>
                        <SwitchButton
                            checked={isChecked}
                            onChange={handleChange}
                            handleDiameter={26}
                            onHandleColor={"#0D0D0D"}
                            offHandleColor={"#FFFFFF"}
                            checkedIcon={<img src={defaultSubServiceCheckedIcon} alt="defaultSubServiceCheckedIcon" className="manageSubCategoryCardSwitchCheckedIcon" />}
                            uncheckedIcon={false}
                        />
                    </div>
                </div>
            </div>
            <div className={s.manageSubCategoryCardBottomWrapper}>
                <div className={s.manageSubCategoryCardBottomText}>
                    <span><FormattedMessage {...messages.baseFare} />&nbsp;</span>
                    {
                        pricingType === 'fixed' ? (
                            <span>
                                <span>{symbol}</span>
                                <span>{baseFare}</span>
                                <span>/<FormattedMessage {...messages.quantitlyLabel} /></span>
                            </span>
                        ) : (
                            <span>
                                <span>{symbol}</span>
                                <span>{baseFare}</span>
                                <FormattedMessage {...messages.perHourLabel} />
                            </span>
                        )
                    }
                </div>
                {isChecked && isPriceEditable && <>
                    <Link onClick={(e) => handlePopupModal(e)} className={s.manageSubCategoryCardBottomLink}>
                        <EditFareIcon />
                        {formatMessage(messages.editFare)}
                    </Link>
                </>}
            </div>
        </>
    )
}

const mapState = (state) => ({});

const mapDispatch = {
    openBaseFareModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ManageSubCategoryItem)));